import { useCallback, useState } from 'react';
import LeadsService from 'src/services/leads';

const useLeadsService = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  const getCallbackMetaLeadsService = useCallback(
    async (code: string, state: string, customerId: number) => {
      try {
        setIsLoading(true);
        const response = await LeadsService.getCallbackMetaLeads(
          code,
          state,
          customerId
        );
        setIsLoading(false);
        return response;
      } catch (error) {
        console.error('Erro ao buscar status dos leads', error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const getUrlMetaLeadsService = useCallback(async (customer_id: number) => {
    try {
      setIsLoading(true);
      const response = await LeadsService.getUrlMetaLeads(customer_id);
      setIsLoading(false);
      return response;
    } catch (error) {
      console.error('Erroao buscar status dos leads', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getStatusLeadsService = useCallback(async (customerId: number) => {
    try {
      setIsLoading(true);
      const response = await LeadsService.getStatusLeads(customerId);
      setIsLoading(false);
      return response;
    } catch (error) {
      console.error('Erro ao buscar status dos leads', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const deleteMetaLeadsService = useCallback(async (customerId: number) => {
    try {
      setIsLoadingDelete(true);
      const response = await LeadsService.deleteMetaLeads(customerId);
      setIsLoadingDelete(false);
      return response;
    } catch (error) {
      console.error('Erro ao deletar leads', error);
      throw error;
    } finally {
      setIsLoadingDelete(false);
    }
  }, []);

  return {
    getCallbackMetaLeadsService,
    getUrlMetaLeadsService,
    getStatusLeadsService,
    deleteMetaLeadsService,
    isLoading,
    isLoadingDelete,
  };
};

export default useLeadsService;
